import { DropDownItem } from '../../../fields/dropdown-item.model';
import { Range } from '../../entities/range.model';
import { Table } from '../../entities/table.model';


export class TaxonomyValuesTable extends Table<{ [taxonomyId: number]: { range: Range, items: DropDownItem[]; }; }> {
  constructor(
    range: Range) {
    super(range, false, {});
  }

  add(taxonomyId: number, items: DropDownItem[]): boolean {
    if (!this.exists(taxonomyId)) {
      const rowDiff = items.length * 2 /* codes + values */
        + 1 /* items count row */
        - (this.range.rowCount - 1 /* header row*/);

      if (rowDiff > 0) {
        this.range.rowCount += rowDiff;
      }

      if (this.containsData) {
        this.range.columnCount++;
      } else {
        this.containsData = true;
      }

      const range = new Range(
        items.length + 2, // 2 - header row + items count row
        this.range.lastColumnIndex,
        items.length,
        1,
        this.range.sheetName);

      this.cache[taxonomyId] = { range: range, items: items };
      return true;
    }

    return false;
  }

  remove(taxonomyId: number): boolean {
    if (this.exists(taxonomyId)) {
      delete this.cache[taxonomyId];

      if (this.range.columnCount == 1) {
        this.containsData = false;
      } else {
        this.range.columnCount--;
      }

      return true;
    }

    return false;
  }

  getItems(taxonomyId: number): DropDownItem[] {
    const items = this.cache[taxonomyId]?.items;
    return items ? [...items] : undefined;
  }

  getRange(taxonomyId: number): Range {
    return this.cache[taxonomyId]?.range;
  }

  exists(taxonomyId: number): boolean {
    return this.cache.hasOwnProperty(taxonomyId);
  }
}